import { AlertInputs } from "@/interface/types";
import style from "../styles/alert.module.css";

export const MilesAlert = ({ text, type, html }: AlertInputs) => {
  let promise = new Promise((resolve) => {
    const elm = document.createElement("div");
    elm.innerHTML = `
      <section class='${style.modal} ${style[type]}'>
        <div class='${style["content-container"]}'>
            <div class='${style.icon}'>
              <img src="/newImages/MilesEducationWebsite-2024/alert-lib/${type}.svg" alt="${type}" />
            </div>
            ${html ? html : `<p class='${style.text}'>${text}</p>`}
        </div>
        <div style="display:flex;justify-content:end">
          <button class='${style.btn}' id="closeBtn" >Ok</button>
        </div>
      </section>
      <div class='${style.overlay}'></div>
    `;
    let btnClick = elm.querySelector("#closeBtn");
    btnClick?.addEventListener("click", () => {
      resolve("i have resolved");
      document.body.removeChild(elm);
    });

    document.body.appendChild(elm);
  });

  return promise;
};
